import React from 'react';
import styled from 'styled-components';
import media from 'utils/media';
import PropTypes from 'prop-types';

const CardContainer = styled.div`
  width: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
  margin-bottom: ${props => (props.noMargin ? '0rem' : props.mb)};

  ${media.customLG.css`
  flex-direction: ${props =>
    (props.flexDirection ? props.flexDirection : 'row')};
  margin-bottom: ${props => props.mb};
  `}

  justify-content: center;
  align-items: flex-start;
  align-content: center;
`;

const CardImage = styled.div`
  flex: 1;
  width: 100%;
`;

const CardDescription = styled.div`
  flex: 1;
  padding-top: calc(3rem - 16px);
  padding: 3rem 3rem;
  ${media.sm.css`
  padding-top: calc(3rem - 16px);
  `}
  ${media.customLG.css`
  padding: 3rem;
  padding-bottom: calc(3rem - 16px);
  padding-top: calc(3rem - 16px);
  `};
`;

const Card = ({ p, flexDirection, mb, noMargin, image, children }) => (
  <CardContainer
    p={p}
    flexDirection={flexDirection}
    mb={mb}
    noMargin={noMargin}
  >
    <CardImage>{image}</CardImage>
    <CardDescription>{children}</CardDescription>
  </CardContainer>
);

Card.propTypes = {
  p: PropTypes.string.isRequired,
  flexDirection: PropTypes.string.isRequired,
  mb: PropTypes.string.isRequired,
  noMargin: PropTypes.bool,
  image: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

Card.defaultProps = {
  noMargin: false,
};

export default Card;



// WEBPACK FOOTER //
// ./src/components/NYCMeetUpLanding/components/Card.js